module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-1.deac3816.jpg";